<template>
  <div class="zj-form-container">
    <el-container>
      <zj-layout-main>
        <el-form
          ref="BusinessBalanceform"
          status-icon
          :model="BusinessBalanceform"
          :rules="rules"
          label-width="120px"
          class="BusinessBalanceInfo"
          style="width: 90%;"
          v-loading="loading"
          :element-loading-text="loadingText"
        >
          <el-row>
            <el-col>
              <el-form-item label="商户编号" prop="BusinessName">
                  <el-input v-model="BusinessBalanceform.SubMerId" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="收款户名" prop="AccountName">
                  <el-input v-model="BusinessBalanceform.AccountName" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="收款账号" prop="Account">
                  <el-input v-model="BusinessBalanceform.SubMerchantAccNo" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="收款银行" prop="RecBankNo">
                  <el-select  filterable placeholder="请选择"  v-model="BusinessBalanceform.RecBankNo" :disabled="true">
                    <el-option
                      v-for="item in Banks"
                      :key="item.BankNo"
                      :label="item.BankName"
                      :value="item.BankNo">
                    </el-option>
                  </el-select>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="商户余额" prop="Balance">
                  <el-input v-model="BusinessBalanceform.Balance" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col v-if="IsOutPay==true">
              <el-form-item label="提现金额" prop="TrxAmount">
                  <el-input-number :precision="2" :step="1" :min="0"  v-model="BusinessBalanceform.TrxAmount"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col v-if="IsOutPay==true">
              <el-form-item label="附言" prop="Remark">
                  <el-input v-model="BusinessBalanceform.Remark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-footer style="text-align: center;">
        <el-button v-if="IsOutPay==true" @click="OutMonty">提现</el-button>
        <el-button @click="OnCancel">取消</el-button>
      </el-footer>
    </el-container>
  </div>
</template>

<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  .avatar {
    width: 80px;
    height: 80px;
    display: block;
  }
</style>


<script>
import WebApis from "../../../apis";
import utils from "../../../../../../utils";

export default {
  name: "BusinessBalanceInfoPage",
  data() {
    return {
      BusinessBalanceform: {
        SubMerId: "",
        AccountName:"",
        SubMerchantAccNo:"",
        RecBankNo:"",
        Balance:"",
        TrxAmount:"",
        Remark:""
      },
      resData: "",
      BusinessInfo:"",
      Banks:[]
    };
  },
  props: {
    BusinessCode: {
      type: String,
      default: ""
    },
    AccountName:{
      type: String,
      default: ""
    },
    SubMerchantAccNo:{
      type: String,
      default: ""
    },
    RecBankNo:{
      type: String,
      default: ""
    },
    IsOutPay: {
      type: Boolean,
      default: true,
    }
  },
  created: function () {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      return utils.waitAll([
         ()=>this.GetBanks()]).then(()=>{
               this.GetInfo();
          });
    },
    OnCancel() {
      this.$emit("clickCancel", {});
    },
    GetBanks()
    {
      return new WebApis.BankApi().FindAll().then((res)=>{
        console.log(res);
         if (res.data.Data) {
             this.Banks=res.data.Data;
         }
      });
    },
    GetInfo() {
      console.log("商户编号",this.BusinessCode);
      if (this.BusinessCode) {
        this.BusinessBalanceform.SubMerId=this.BusinessCode;
        this.BusinessBalanceform.AccountName=this.AccountName;
        this.BusinessBalanceform.SubMerchantAccNo=this.SubMerchantAccNo;
        this.BusinessBalanceform.RecBankNo=this.RecBankNo;

        let BusinessBalanceSearch = {
          SubMerId: this.BusinessCode
        };
        console.log("BusinessBalanceSearch",BusinessBalanceSearch);
        return new WebApis.BusinessBalanceApi()
          .GetItemBySubMerId(BusinessBalanceSearch)
          .then((res) => {
            console.log("商户余额结果",res);
            if (res.data.Data) {
              this.resData = res.data.Data;
              this.BusinessBalanceform.Balance = this.resData.Balance;
            }
          })
          .catch((e) => {
            console.log("商户余额结果异常",e);
            this.$message({
              showClose: true,
              message: e.RspMsg
                ? "获取商户余额信息失败!" + e.RspMsg
                : "获取商户余额信息失败!",
              type: "error",
            });
            return false;
          });
      }
    },
    OutMonty()
    {
      let OutPaymentRequest={
          SubMerId: this.BusinessBalanceform.SubMerId,
          AccountName:this.BusinessBalanceform.AccountName,
          Account:this.BusinessBalanceform.SubMerchantAccNo,
          RecBankNo:this.BusinessBalanceform.RecBankNo,
          TrxAmount:this.BusinessBalanceform.TrxAmount+"",
          DrawingFlag:"0"
      }

      if(this.BusinessBalanceform.TrxAmount>this.BusinessBalanceform.Balance)
      {
         this.$message({
                showClose: true,
                message: "提现金额不能大于余额",
                type: "error",
              });
              
            return false;
      }

        return new WebApis.BusinessOutPaymentApi().SubMerAccOutPayment(OutPaymentRequest)
          .then((res)=>{
            console.log("商户提现结果",res);

          if(res.RspCode=="1")
          {
              this.$message({
                showClose: true,
                message: "提现成功!",
                type: "success",
              });
              this.$emit("clickOk", {});
          }
          else
          {
            this.$message({
                showClose: true,
                message: res.RspMsg+","+res.DescExtend,
                type: "error",
              });
              
            return false;
          }
        }) .catch((e) => {
            console.log("提现失败",e);
            this.$message({
              showClose: true,
              message: e.RspMsg
                ? e.RspMsg
                : "提现失败!",
              type: "error",
            });
            return false;
          });
    }
  },
};
</script>
